import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { TableFields as tf } from '../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '姓名',
            dataIndex: tf.name,
            key: tf.name,
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '证照号码',
            dataIndex: tf.cardNo,
            key: tf.cardNo,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所得项目',
            dataIndex: tf.incomeProject,
            key: tf.incomeProject,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所得期间起',
            dataIndex: tf.incomeStartTime,
            key: tf.incomeStartTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '所得期间止',
            dataIndex: tf.incomeEndTime,
            key: tf.incomeEndTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收入(元)',
            dataIndex: tf.incomeAmount,
            key: tf.incomeAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '免税收入(元)',
            dataIndex: tf.freeTaxAmount,
            key: tf.freeTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '实际捐赠额(元)',
            dataIndex: tf.donationAmount,
            key: tf.donationAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '捐赠方式',
            dataIndex: tf.donationType,
            key: tf.donationType,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '准予扣除的捐赠额(元)',
            dataIndex: tf.allowDeductDonationAmount,
            key: tf.allowDeductDonationAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '扣除及减除项目合计(元)',
            dataIndex: tf.deductTotalAmount,
            key: tf.deductTotalAmount,
            width: cellWidth.time,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '应纳税所得额(元)',
            dataIndex: tf.needPayTaxIncomeAmount,
            key: tf.needPayTaxIncomeAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '税率',
            dataIndex: tf.taxRate,
            key: tf.taxRate,
            width: cellWidth.normal,
            align: 'center',
            render: tooltip
        },
        {
            title: '应纳税额(元)',
            dataIndex: tf.needPayTaxAmount,
            key: tf.needPayTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '减免税额(元)',
            dataIndex: tf.reductionTaxAmount,
            key: tf.reductionTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '应扣缴税额(元)',
            dataIndex: tf.needDeductTaxAmount,
            key: tf.needDeductTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '已扣缴税额(元)',
            dataIndex: tf.deductedPayTaxAmount,
            key: tf.deductedPayTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '应补（退）税额(元)',
            dataIndex: tf.needReturnTaxAmount,
            key: tf.needReturnTaxAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '会员身份',
            dataIndex: tf.memberIdentity,
            key: tf.memberIdentity,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: tf.remark,
            key: tf.remark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '新建时间',
            dataIndex: tf.createTime,
            key: tf.createTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ]);

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record, index) => index}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;